module.exports = __webpack_public_path__ + "static/img/11.b5046ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/11.png
// module id = u0tx
// module chunks = 35